import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/theme-provider";
import { I18nProvider } from "@/components/i18n-provider";
import Home from "@/pages/home";
import ForRestaurants from "@/pages/for-restaurants";
import Solutions from "@/pages/solutions";
import Integrations from "@/pages/integrations";
import Blog from "@/pages/blog";
import BlogPost from "@/pages/blog/post";
import TermsOfService from "@/pages/terms";
import PrivacyPolicy from "@/pages/privacy-policy";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="mezepay-theme">
      <I18nProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/for-restaurants" element={<ForRestaurants />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
